/**
 * SyntroJS - FastAPI for Node.js
 * Main entry point
 */

// Application exports
export * from './application';
// Core exports
export * from './core';
// Domain exports
export * from './domain';

// Infrastructure exports
export * from './infrastructure';
// Plugins exports
export * from './plugins';
// Security exports
export * from './security';

/**
 * Current version
 */
export const VERSION = '0.3.4-alpha';
